/// <reference types="vite/client" />
export const BASE_API_URL =
  "https://dxgn02z9kk.execute-api.eu-west-2.amazonaws.com/prod/v1/";
export const WEBSOCKET_URL =
  "wss://6alr2o8rhc.execute-api.eu-west-2.amazonaws.com/prod";
export const FILE_BASE_URL =
  "https://business-crm-prod.s3.eu-west-2.amazonaws.com/";
